<template>
  <div class="slider" @click="onClick">
    <div class="slider-bar" :style="{ width: `${format(value)}%` }">
      <div
        class="slider-btn"
        @touchstart="onTouchStart"
        @touchmove="onTouchMove"
        @touchend="onTouchend"
        @touchcancel="onTouchend"
      />
    </div>
  </div>
</template>

<script>
import { TouchMixin } from './touch'
export default {
  mixins: [TouchMixin],
  props: {
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 100
    },
    step: {
      type: Number,
      default: 1
    },
    disabled: {
      type: Boolean,
      default: false
    },
    value: Number
  },
  methods: {
    onClick() {
      event.stopPropagation()
      if (this.disabled) return

      const rect = this.$el.getBoundingClientRect()
      const value = ((event.clientX - rect.left) / rect.width) * 100
      this.updateValue(value, true)
    },
    onTouchStart(e) {
      if (this.disabled) return

      this.touchStart(e)
      this.startValue = this.format(this.value)
      this.$emit('movestart')
    },
    onTouchMove(e) {
      if (e.cancelable) {
        e.preventDefault()
        e.stopPropagation()
      }
      if (this.disabled) return

      this.touchMove(event)
      const rect = this.$el.getBoundingClientRect()
      const diff = (this.deltaX / rect.width) * 100
      this.updateValue(this.startValue + diff)
    },
    onTouchend() {
      if (this.disabled) return
      this.updateValue(this.value, true)
      this.$emit('moveend')
    },
    updateValue(value, end) {
      value = this.format(value)
      this.$emit('input', value)

      if (end) {
        this.$emit('change', value)
      }
    },
    format(value) {
      return (
        Math.round(Math.max(this.min, Math.min(value, this.max)) / this.step) *
        this.step
      )
    }
  }
}
</script>
<style scoped>
.slider {
  position: relative;
  width: 100%;
  height: 8px;
  border-radius: 8px;
  background-color: #e5e5e5;
}
.slider-bar {
  position: relative;
  height: 100%;
  border-radius: 8px;
  background-color: #43b1fe;
  background-image: linear-gradient(-116deg, #43b1fe 0%, #1f81ee 95%);
}
.slider-btn {
  position: absolute;
  right: -4px;
  top: -6px;
  width: 8px;
  height: 20px;
  border-radius: 8px;
  background-color: #2587f1;
}
</style>
